// extracted by mini-css-extract-plugin
module.exports = {"LandingPage":"LandingPage__LandingPage___3svdU"};